import { memo } from "react";
import { Status } from "consts/transactions";
import CassetteLayout from "ui/layouts/Cassette";
import TransactionStatusCassette from "./TransactionStatusCassette";
import AvgTransactionSize from "./AvgTransactionSize";

const StatisticDashboardCassettes = () => (
    <CassetteLayout>
        <TransactionStatusCassette
            data-test-id='dashboard.transaction-status-cassette.succeeded'
            statusLabel='Succeeded trx.'
            status={Status.Succeeded}
        />
        <TransactionStatusCassette
            data-test-id='dashboard.transaction-status-cassette.failed'
            statusLabel='Failed trx.'
            status={Status.Failed}
        />
        <TransactionStatusCassette
            data-test-id='dashboard.transaction-status-cassette.rejected'
            statusLabel='Rejected trx.'
            status={Status.Rejected}
        />
        <AvgTransactionSize />
    </CassetteLayout>
);

export default memo(StatisticDashboardCassettes);
